import {
  selectIsDirty,
  selectIsValidatingDiscount,
  selectTransactionPaymentType,
} from 'app/features/orders/redux/order/refundSlice'
import {useSelector} from 'react-redux'
import ProcessRefund from './ProcessRefund'
import {RootState} from 'setup'
import {useNavigate, useParams} from 'react-router-dom'
import FullRefundButton from './FullRefundButton'
import {FC} from 'react'
import {PAYMENT_TYPES} from 'app/constant/payment'
import {PaxPartialRefundButton, PaxFullRefundButton} from './PaxRefundButton'
import {paymentProviderTypes} from 'app/constant'

export const RefundActionWrapper = () => {
  const {orderId} = useParams<any>()
  const history = useNavigate()
  const isValidating = useSelector<RootState, boolean>(selectIsValidatingDiscount)
  const isDirty = useSelector<RootState, boolean>(selectIsDirty)

  const handleClick = () => {
    history(`/orders/${orderId}/fulfillments/view`)
  }

  return (
    <div className='d-flex justify-content-end align-items-center flex-row mt-5'>
      <div className='me-5'>
        <button
          id='btnOrderCancel'
          type='button'
          className='btn explore-btn-outline'
          onClick={handleClick}
          disabled={isValidating}
        >
          Cancel
        </button>
      </div>
      <RefundButton disabled={isValidating || !isDirty} />
      <ButtonFullRefund disabled={isValidating} />
    </div>
  )
}

export default RefundActionWrapper

type RefundButtonProps = {
  disabled: boolean
}
const RefundButton: FC<RefundButtonProps> = ({disabled}) => {
  const paymentType = useSelector<RootState, string>(selectTransactionPaymentType)
  const user = useSelector<RootState, any>(({auth}) => auth.user)

  if (user) {
    const {store, locationId} = user
    if (
      paymentType === PAYMENT_TYPES.scanner &&
      store.paymentProviderType === paymentProviderTypes.elavon
    ) {
      return <PaxPartialRefundButton disabled={disabled} locationId={locationId} />
    }
    return <ProcessRefund disabled={disabled} />
  }
  return null
}

const ButtonFullRefund: FC<RefundButtonProps> = ({disabled}) => {
  const paymentType = useSelector<RootState, string>(selectTransactionPaymentType)
  const user = useSelector<RootState, any>(({auth}) => auth.user)

  if (user) {
    const {store, locationId} = user
    if (
      paymentType === PAYMENT_TYPES.scanner &&
      store.paymentProviderType === paymentProviderTypes.elavon
    ) {
      return <PaxFullRefundButton disabled={disabled} locationId={locationId} />
    }
    return <FullRefundButton disabled={disabled} />
  }
  return null
}
